import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { InputGroup, Button } from "@blueprintjs/core";
import { validate } from "validate.js";
import { Translate, I18n } from "react-redux-i18n";
import validators from "../containers/auth/RecoverPassword/validators";
import { recoverPassword } from "../store/users/operations";
import { isUpdatingUser } from "../store/users/selectors";

export default function GrannboxForgotPassword({ goTo }) {
    const [errors, setErrors] = useState({});
    const [values, setValues] = useState();
    const isLoading = useSelector(isUpdatingUser);
    const dispatch = useDispatch()

    const submitForm = (e) => {
        e.preventDefault();
        const validationErrors = validate(values, validators);
        setErrors(validationErrors ? validationErrors : {})
        if (!validationErrors) {
            dispatch(recoverPassword(values.u_name));
        }
    }

    const updateFields = (event) => {
        const formValues = {
            ...values,
            [event.target.id]: event.target.value,
        }
        setValues(formValues);
    }

    return (
        <>
        <div className="fade-on-entry">
            <h1><Translate value="grannbox_onboarding.forgot_pass_header" /></h1>
            <p className="large-paragraph"><Translate value="grannbox_onboarding.forgot_pass_subheader" /></p>
            <form onSubmit={submitForm} className="login-form">
                <div
                    className={
                        errors.u_name
                            ? "form-group error"
                            : "form-group"
                    }>
                    {errors.u_name && (
                        <label htmlFor="u_name">
                            <Translate value={errors.u_name[0]} />
                        </label>
                    )}
                    <InputGroup
                        type="email"
                        placeholder={I18n.t("recover_password.email_placeholder")}
                        fill={true}
                        id="u_name"
                        disabled={isLoading}
                        intent={errors.u_name ? "danger" : ""}
                        onChange={updateFields}
                        required
                    />
                </div>

                <Button
                    disabled={isLoading}
                    loading={isLoading}
                    className="login-button"
                    intent="primary"
                    fill={true}
                    type="submit">
                    <Translate value="recover_password.button" />
                </Button>
            </form>
            <div className="flexbox">
                <div className="fake-link" onClick={() => goTo('login')}>
                    <Translate value="grannbox_onboarding.back_to_login" />
                </div>
            </div>
        </div>
        </>
    )
}
